<template>
    <div class="home">
        <div class="home-left">
            <div class="left-top">
                <img src="https://colearn.foxconn.com/files/halo-appendix/author_bg.jpeg" style="width: 100%;" alt="">
                <img src="https://colearn.foxconn.com/files/halo-appendix/%E6%A0%A1%E9%95%BF%E7%85%A7%E7%89%87.png"
                    class="left-top-avatar" alt="">
                <div class="left-top-content">
                    <h4 class="left-top-content-title">校长随笔</h4>
                    <div class="left-top-content-block-wrapper">
                        <div class="left-top-content-block">
                            <p class="left-top-content-block-textOne">{{ categoryCount }}</p>
                            <p class="left-top-content-block-textTwo">分类数</p>
                            <div style="height: 1.8rem; background: rgb(229 229 229); width: .1rem; position: absolute; right: -1.5rem; top: 50%; transform: translateY(-40%);"></div>
                        </div>
                        <div class="left-top-content-block">
                            <p class="left-top-content-block-textOne">{{ tagCount }}</p>
                            <p class="left-top-content-block-textTwo">标签数</p>
                        </div>
                        <div class="left-top-content-block">
                            <div style="height: 1.8rem; background: rgb(229 229 229); width: .1rem; position: absolute; left: -1.5rem; top: 50%; transform: translateY(-40%);"></div>
                            <p class="left-top-content-block-textOne">{{ total }}</p>
                            <p class="left-top-content-block-textTwo">文章数</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="left-bottom">
                <div class="left-bottom-header">
                    <svg-icon icon-file-name="hot"></svg-icon>
                    <p style="font-weight: 400;">最新文章</p>
                </div>
                <div class="left-bottom-content" @click="goToArticle()">
                    <div v-for="(item, index) in latestArticles" @click="goToArticle(item)" :key="index" class="left-bottom-content-item">
                        <p class="left-bottom-content-item-text">{{ item.title }}</p>
                        <svg t="1741937691291" class="svg-icon" viewBox="0 0 1024 1024" version="1.1"
                            xmlns="http://www.w3.org/2000/svg" p-id="51946" width="20" height="20">
                            <path d="M588.8 520.533333l29.866667-29.866666 51.2 51.2 170.666666-170.666667-179.2-179.2-170.666666 170.666667 38.4 38.4-29.866667 29.866666L426.666667 358.4 657.066667 128l243.2 243.2-230.4 230.4-81.066667-81.066667z m-157.866667-25.6l-29.866666 29.866667-38.4-38.4-170.666667 170.666667 179.2 179.2 170.666667-170.666667-51.2-51.2 29.866666-29.866667 81.066667 81.066667L371.2 896 128 657.066667 358.4 426.666667l72.533333 68.266666z m183.466667-123.733333l29.866667 29.866667-273.066667 273.066666-29.866667-25.6 273.066667-277.333333z"
                                fill="#444444" p-id="51947"></path>
                        </svg>
                    </div>
                </div>
            </div>
        </div>

        <div class="home-right">
            <div class="home-right-content">
                <div style="width: 100%;padding-bottom: .5rem; display: flex; align-items: center; gap: .6rem; box-sizing: border-box; height: 2rem; border-bottom: 1px solid #e2e2e2;">
                    <h4 style="margin: 0;color: #FB6C28;font-size: .9rem;font-weight: 400;">最新文章</h4>
                </div>

                <div v-for="(item, index) in articleList" :key="index" class="home-right-content-item" @click="goToArticle(item)">
                    <h2 class="home-right-content-item-title">{{ item.title }}</h2>
                    <p class="home-right-content-item-text"> {{ item.desc }}</p>
                    <p class="home-right-content-item-footer">{{ item.published ? item.published.slice(0, 10) : '' }} /
                        <svg-icon icon-file-name="view_count"></svg-icon> {{ item.viewCount }} / 
                        <!-- <svg-icon  icon-file-name="comment_count"></svg-icon> {{ item.commentCount }} /  -->
                        <svg-icon icon-file-name="like_count"> </svg-icon> {{ item.likeCount }}
                    </p>
                </div>
            </div>

            <div class="home-right-content-page">
                <el-pagination class="el-pagination" v-if="!isSmall" background :layout="paginationLayout" :total="total"  :current-page="page" @current-change="fetchData" > </el-pagination>
                <el-pagination class="el-pagination" v-if="isSmall" small background :layout="paginationLayout" :total="total"  :current-page="page" @current-change="fetchData" > </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import articleApi from '@/api/articleApi'
import categoriesApi from '@/api/categoriesApi'

export default {
    name: "Home",
    computed: {
        paginationLayout() {
            const width = window.innerWidth
            return width < 768 
            ? 'prev, pager, next' // 小屏幕去掉 total 和 jumper
            : 'total, prev, pager, next, jumper' // 大屏幕正常显示
        },
        isSmall() {
            const width = window.innerWidth
            if (width < 568) {
                return true
            } else{
                return false
            }
        }
    },
    data() {
        return {
            total: 0, // 数据库中的总记录数
            page: 1, // 默认页码
            limit: 10, // 每页记录数
            searchObj: {
                title: '',
                sort: ''
            },
            articleList: [],
            latestArticles: [],
            categoryCount: 0,
            tagCount: 0
        }
    },
    created() {
        this.fetchData()
        this.getCategoriesAndTagCount()
    },
    methods: {
        goToArticle(item) {
            window.open(
                this.$router.resolve({
                    path: '/article',
                    query: { key: item.metadataName }
                }).href,
                '_blank'
            )
        },
        getCategoriesAndTagCount() {
            categoriesApi.getCategoriesAndTagCount().then(res => {
                this.categoryCount = res.data.categoryCount
                this.tagCount = res.data.tagCount
            })
        },
        fetchData(page = 1) {
            // 获取数据
            this.page = page
            articleApi.getArticlePageList(this.page, this.limit, this.searchObj).then(response => {
                this.articleList = response.data.data.records.map(item => {
                    // 创建一个新的字段 desc，移除 HTML 标签
                    const plainText = item.content ? item.content.replace(/<[^>]+>/g, '') : ''
                    return {
                        ...item,
                        desc: plainText
                    }
                })
                this.total = response.data.data.total
                for (let i = 0; i < 5; i++) {
                    if(this.articleList[i]) {
                        this.latestArticles[i] = this.articleList[i]
                    }
                }
            })
        },
    }
}
</script>

<style scoped lang="scss">
/* 其他 SCSS 文件 */
@use '../../assets/styles/variables' as *;

.home {
    text-align: center;
    max-width: 1200px;
    margin: 0 auto;
    margin-top: 1rem;
}

.home-left {
    float: left;
    width: 22%;
    margin-right: 2%;
}

.left-top {
    width: 100%;
    background: $theme-white;
    height: 16rem;
    border-radius: .5rem;
    position: relative;
    overflow: hidden;
}


.left-top-content {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 8rem;
    z-index: 2;
    background: $theme-white;
    box-shadow: 0px -7px 40px 0px rgba(255, 255, 255, 1);
    /* 向上的阴影 */
}

.left-top-content-title {
    margin-top: .67rem;
    color: $theme-color;
}

.left-top-content-block-wrapper {
    display: flex;
    justify-content: center;
    gap: 2.5rem;
}

.left-top-content-block {
    position: relative;
}

.left-top-content-block-textOne {
    margin: .2rem;
    font-size: 1.2rem;
    font-weight: 500;
}

.left-top-content-block-textTwo {
    margin: 0;
    font-size: .77rem;
    color: #353535;
    font-weight: 300;
}



.left-top-avatar {
    width: 4.2rem;
    position: absolute;
    z-index: 5;
    bottom: 8.2rem;
    left: 50%;
    transform: translateX(-50%);
    border: .38rem solid #ececf5;
    border-radius: .36rem;
}

.left-bottom {
    margin-top: 1rem;
    width: 100%;
    background: $theme-white;
    height: 16rem;
    border-radius: .5rem;
    position: relative;
    overflow: hidden;
    box-sizing: border-box;
}

.left-bottom-header {
    width: 100%;
    padding: .9rem;
    display: flex;
    align-items: center;
    gap: .6rem;
    box-sizing: border-box;
    height: 2.8rem;
    border-bottom: 1px solid #e2e2e2;
}

.left-bottom-content {
    width: 100%;
    padding: 0 .9rem;
    padding-top: .7rem;
    box-sizing: border-box;
}

.left-bottom-content-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: gray;
    margin-top: .6rem;
}

.left-bottom-content-item-text {
    margin: 0;
    font-size: .86rem;
    text-align: start;
    width: 88%;
    font-weight: 400;
    cursor: pointer;
    white-space: nowrap;
    /* 防止文本换行 */
    overflow: hidden;
    /* 超出容器的部分隐藏 */
    text-overflow: ellipsis;
    /* 超出部分用省略号表示 */
    position: relative;
    /* 使伪元素相对于这个元素定位 */
    display: inline-block;
    /* 确保宽度和高度生效 */
    color: initial-value;
    /* 设置初始颜色，替换为实际颜色 */
    transition: color 0.5s ease;
    /* 平滑的颜色过渡 */
}

/* 添加下划线效果 */
.left-bottom-content-item-text::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: .06rem;
    /* 下划线的高度 */
    background-color: $theme-color;
    /* 设置您希望的下划线颜色 */
    transform: scaleX(0);
    /* 初始状态，没有宽度 */
    transform-origin: left;
    /* 缩放从左边开始 */
    transition: transform 0.5s ease;
    /* 平滑的过渡效果 */
}

/* hover 状态下的样式 */
.left-bottom-content-item:hover .left-bottom-content-item-text {
    color: $theme-color;
    /* 替换为您希望的悬停文本颜色 */
}

.left-bottom-content-item:hover .svg-icon path {
    fill: $theme-color;
    /* 替换为您希望的悬停SVG颜色 */
}

.left-bottom-content-item-text:hover::after {
    transform: scaleX(1);
    /* 完全显示下划线 */
}

.home-right {
    float: right;
    width: 76%;
}

.home-right-content {
    width: 100%;
    background: $theme-white;
    border-radius: .5rem;
    min-height: 80vh;
    box-sizing: border-box;
    padding: .9rem;
}

.home-right-content-item {
    text-align: start;
    padding-bottom: 1rem;
    border-bottom: 1px solid #e2e2e2;
    cursor: pointer;
}

.home-right-content-item:hover .home-right-content-item-title {
    color: $theme-color;
}

.home-right-content-item-title {
    font-weight: 400;
    transition: color 0.3s ease;
    /* 平滑的颜色过渡 */
}

.home-right-content-item-text {
    font-weight: 300;
    font-size: 1rem;
    color: #909399;
    display: -webkit-box;
    /* 使用弹性盒子模型，使得-webkit-line-clamp有效 */
    -webkit-box-orient: vertical;
    /* 子元素垂直排列 */
    -webkit-line-clamp: 2;
    /* 显示的行数 */
    overflow: hidden;
    /* 隐藏溢出的内容 */
    text-overflow: ellipsis;
    /* 超出部分用省略号表示 */
    line-height: 1.5;
    /* 根据实际情况调整行高 */
    max-height: calc(1.5 * 2rem);
    /* 行高乘以显示的行数，确保最多显示两行 */
    margin-bottom: .2rem;
}

.home-right-content-item-footer {
    font-size: .9rem;
    display: flex;
    align-items: center;
    gap: .2rem;
    margin: 0;
    color: #909399;
    font-weight: 400;
}

.home-right-content-page {
    margin-top: 2rem;
}


@media (max-width: 1268px) {
    .home {
        text-align: center;
        max-width: 1080px;
        margin: 0 auto;
        margin-top: 1rem;
    }
}

@media (max-width: 1168px) {
    .home {
        text-align: center;
        max-width: 960px;
        margin: 0 auto;
        margin-top: 1rem;
    }
}

@media (max-width: 1000px) {
    .home {
        text-align: center;
        max-width: 92vw;
        margin: 0 auto;
        margin-top: 1rem;
    }

    .home-left {
        display: none;
    }

    .home-right {
        width: 100%;
    }
}

@media (max-width: 768px) {
    .home-right-content-item-title {
       font-size: 1.1rem;
    }

    .home-right-content-item-text {
        font-size: .9rem;
    }

    .home-right-content-item-footer {
        font-size: .8rem;
    }

    .el-pagination {
        width: 100% !important;
        margin: 0 !important;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-evenly;
        .el-pagination__total {
            width: 160px !important;
            height: 50px !important;
            line-height: 50px !important;
        }
        .el-pagination__sizes {
            width: 160px !important;
            height: 50px !important;
            line-height: 50px !important;
        }
        .btn-prev,
        .btn-next {
            width: 50px !important;
            padding: 0;
        }
        .el-pager {
            width: 200px !important;
        }
        .el-pagination__jump {
            width: 100px !important;
            height: 50px !important;
            line-height: 50px !important;
            margin: 0;
            margin-left: calc(100% / 2 - 120px);
        }
    }

}

@media (max-width: 568px) {
    .home-right-content-item-title {
       font-size: 1rem;
       margin: .5rem 0;
    }

    .home-right-content-item-text {
        font-size: .85rem;
    }

    .home-right-content-item-footer {
        font-size: .7rem;
    }
}
</style>

<style lang="scss">
//修改鼠标滑过的颜色
.el-pagination.is-background .el-pager li:hover {
    color: #FB6C28;
}
.el-pagination.is-background .el-pager li:not(.disabled):hover {
    color: #FB6C28;
}
.el-pagination.is-background .el-pager li:not(.disabled).active:hover {
    background-color: #FB6C28;
}
.el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #FB6C28;   // 进行修改背景
}

.el-pagination.is-background .el-pager li:not(.disabled).active:hover {
    color: white;
}
</style>